import * as React from 'react'

import { makeStyles } from 'tss-react/mui'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'

// Peças comuns aos painéis dos dashboards.

export const useCardStyles = makeStyles()((theme) => ({
    card: {
        borderRadius: 14,
        boxShadow: '0px 2px 12px rgba(0,0,0,0.05)'
    },
    numero: {
        fontSize: 28,
        fontWeight: 700,
        lineHeight: 1.2,
        fontVariantNumeric: 'tabular-nums'
    },
    tituloCard: {
        fontWeight: 600,
        fontSize: 15
    },
    nota: {
        fontSize: 13,
        color: theme.palette.text.secondary
    },
    cabecalho: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: theme.spacing(1)
    }
}))

/** Um número em destaque, com o que ele significa embaixo. */
export function Numero({ titulo, valor, nota }: { titulo: string; valor: string; nota: React.ReactNode }) {
    const { classes } = useCardStyles()
    return (
        <Card className={classes.card}>
            <CardContent>
                <Typography color="text.secondary" fontSize={14}>
                    {titulo}
                </Typography>
                <Typography className={classes.numero}>{valor}</Typography>
                <Typography className={classes.nota} component="div">
                    {nota}
                </Typography>
            </CardContent>
        </Card>
    )
}

/**
 * Um gráfico num card. Com `tabela`, o card ganha o botão "Ver tabela": os mesmos números em texto, para quem não
 * distingue as cores e para as cores claras, que ficam abaixo de 3:1 no fundo branco.
 */
export function Grafico({
    titulo,
    nota,
    tabela,
    children
}: {
    titulo: string
    nota?: React.ReactNode
    tabela?: React.ReactNode
    children: React.ReactNode
}) {
    const { classes } = useCardStyles()
    const [verTabela, setVerTabela] = React.useState(false)
    return (
        <Card className={classes.card}>
            <CardContent>
                <Box className={classes.cabecalho}>
                    <Box>
                        <Typography className={classes.tituloCard}>{titulo}</Typography>
                        {nota && (
                            <Typography className={classes.nota} component="div">
                                {nota}
                            </Typography>
                        )}
                    </Box>
                    {tabela && (
                        <Button size="small" sx={{ flexShrink: 0 }} onClick={() => setVerTabela(!verTabela)}>
                            {verTabela ? 'Ver gráfico' : 'Ver tabela'}
                        </Button>
                    )}
                </Box>
                <Box sx={{ mt: 1.5 }}>{verTabela && tabela ? tabela : children}</Box>
            </CardContent>
        </Card>
    )
}
